import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-heatmap-events',
  templateUrl: './heatmap-events.component.html',
  styleUrl: './heatmap-events.component.scss',
})
export class HeatmapEventsComponent {
  isLoading = true;

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.eventsHeatmap$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('eventsHeatmap');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getEventsHeatmap().subscribe();
  }

  get series() {
    return this.analyticsService.eventsHeatmap$.value?.series;
  }

  get xLabels() {
    return this.analyticsService.eventsHeatmap$.value?.hours;
  }

  get yLabels() {
    return this.analyticsService.eventsHeatmap$.value?.days;
  }
}
